import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { LocationQuery } from 'vue-router';
import { PaymentSystem } from './payment-system.interface';

export class PaymentSystemService {
   async getPaymentSystems(query?: LocationQuery): Promise<ApiResource<Array<PaymentSystem>>> {
      const response = await http.get<ApiResource<Array<PaymentSystem>>>(`/payment-systems`, { ...cacheFirstConfig, params: { ...query } });
      return response.data;
   }

   async getPaymentSystem() {
      throw Error('Method not implemented');
   }

   async postPaymentSystem() {
      throw Error('Method not implemented');
   }

   async putPaymentSystem() {
      throw Error('Method not implemented');
   }

   async deletePaymentSystem() {
      throw Error('Method not implemented');
   }
}
